










































import { computed, defineComponent } from '@vue/composition-api';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { windowEnvs } from '@/renderer/scripts/utils/ConstantConfig/PrivateConfig';
import { User } from '@/renderer/scripts/utils/user';

export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });

    const isSjtu = windowEnvs.loginMainEntrance.includes(User.LoginTypeKey.loginWithJAccount);
    const methods = {
      report() {
        const vm = context.root;
        const { isLogined } = vm.$store.getters;
        const loginStr = isLogined ? 'login' : 'nologin';
        reporter.report('link_view', { link_view_report: loginStr });
        dispatchRouter(CONSTANT_URL.offenceUrl, '_blank');
      },
    };
    return {
      innerShow,
      isSjtu,
      ...methods,
    };
  },
});
